import { useMediaQuery } from 'react-responsive';
import ForgotPassword from './RequestReset';
import MobileRequest from './MobileRequest';

const RequestRouter = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 }); // adjust breakpoint if needed

  return isMobile ? <MobileRequest /> : <ForgotPassword />;
};

export default RequestRouter;
